import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { ReseedHolidaysPayload } from '../types';

/** Deletes and regenerates official holidays for the given year only — company-added ones are untouched. */
export function useReseedHolidays() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: (payload: ReseedHolidaysPayload) => timeOffService.reseedHolidays(payload),
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.holidays(orgId, payload.year) });
    },
  });
}
